export default __webpack_public_path__ + "static/mobile-ppq-modal-images-6b71adf66556653745d6cfece913063c.png";